import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import {
  CustomerAssigneeLookup,
  CustomerTypeLookup,
  StateLookup,
} from '../../../services/lookup-api.service';

/** One Customer/Profile field layout shared by New, View, and Edit. */
@Component({
  selector: 'app-customer-profile-fields',
  templateUrl: './customer-profile-fields.component.html',
  styleUrls: ['./customer-profile-fields.component.css'],
})
export class CustomerProfileFieldsComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() viewMode = false;
  @Input() compact = false;
  @Input() loading = false;
  @Input() customerTypesLoading = false;
  @Input() sourcesLoading = false;
  @Input() assigneesLoading = false;
  @Input() statesLoading = false;
  @Input() customerTypes: CustomerTypeLookup[] = [];
  @Input() sources: string[] = [];
  @Input() assignees: CustomerAssigneeLookup[] = [];
  @Input() states: StateLookup[] = [];

  assigneeName(assignee: CustomerAssigneeLookup): string {
    const name = assignee.displayName ?? assignee.userName ?? `User ${assignee.id}`;
    return name.includes('@') ? name.split('@')[0] : name;
  }

  get customerTypeName(): string {
    return this.customerTypes.find(type => type.id === this.form.get('customerInfo.customerTypeId')?.value)?.name ?? 'Not recorded';
  }

  get assignedTo(): string {
    const assignee = this.assignees.find(user => user.id === this.form.get('customerInfo.assigneeUserId')?.value);
    return assignee ? this.assigneeName(assignee) : 'Unassigned';
  }

  addressText(group: 'serviceAddress' | 'billingAddress'): string {
    const address = this.form.get(group)!.getRawValue();
    const state = this.states.find(item => item.id === address.stateId)?.code;
    return [address.line1, address.line2, address.city, state, address.zip].filter(Boolean).join(', ') || 'No address recorded';
  }

  get sameAsService(): boolean {
    return Boolean(this.form.get('billingAddress.sameAsService')?.value);
  }
}
